import React, { Suspense, useEffect, useState } from 'react'
import { Route, Switch } from 'react-router-dom'
import styled from 'styled-components/macro'
import GoogleAnalyticsReporter from '../components/analytics/GoogleAnalyticsReporter'
import Header from '../components/Header'
import Polling from '../components/Header/Polling'
import Popups from '../components/Popups'
import Web3ReactManager from '../components/Web3ReactManager'
import ErrorBoundary from '../components/ErrorBoundary'
import DarkModeQueryParamReader from '../theme/DarkModeQueryParamReader'
import { RedirectDuplicateTokenIds } from './AddLiquidity/redirects'
import MigrateV2 from './MigrateV2'
import MigrateV2Pair from './MigrateV2/MigrateV2Pair'
import Pool from './Pool'
import PoolV2 from './Pool/v2'
import PoolFinder from './PoolFinder'
import RemoveLiquidity from './RemoveLiquidity'
import RemoveLiquidityV3 from './RemoveLiquidity/V3'
import Swap from './Swap'
import { OpenClaimAddressModalAndRedirectToSwap, RedirectPathToSwapOnly, RedirectToSwap } from './Swap/redirects'
import { RedirectDuplicateTokenIdsV2 } from './AddLiquidityV2/redirects'
import { PositionPage } from './Pool/PositionPage'
import AddLiquidity from './AddLiquidity'
import { ThemedBackground } from '../theme'
import ApeModeQueryParamReader from 'hooks/useApeModeQueryParamReader'
import { AssetImages } from 'assets'
import Footer from 'components/Footer'
import { useDarkModeManager, useOverlayCount } from 'state/user/hooks'

const BgWrapper = styled.div`
  position: fixed;
  inset: 0;
`

const AppWrapper = styled.div`
  display: flex;
  flex-flow: column;
  align-items: flex-start;
`

const BodyWrapper = styled.div<{ overlayVisible?: boolean }>`
  display: flex;
  flex-direction: column;
  width: 100%;
  min-height: calc(100vh - 218px);
  padding-top: 80px;
  align-items: center;
  flex: 1;
  z-index: 1;

  ${({ theme, overlayVisible }) => theme.mediaWidth.upToExtraSmall`
    padding-top: 64px;
    min-height: calc(100vh - 135px);
    z-index: ${overlayVisible ? '3' : '1'};
  `};
`

const HeaderWrapper = styled.div`
  ${({ theme }) => theme.flexRowNoWrap}
  width: 100%;
  position: fixed;
  height: 80px;
  top: 0;
  z-index: 2;
  ${({ theme }) => theme.mediaWidth.upToExtraSmall`
    height: 64px;
  `};
`
const FooterWrapper = styled.div`
  width: 100%;
  height: 218px;
  z-index: 2;
  ${({ theme }) => theme.mediaWidth.upToExtraSmall`
    height: 135px;
  `};
`

const Bg = () => {
  return (
    <BgWrapper>
      <div style={{ position: 'absolute', top: 0, left: 0, right: 0, height: '37%' }}>
        <img src={AssetImages.bgTl} style={{ height: '100%', top: 0, left: 0, position: 'absolute' }} />
        <img src={AssetImages.bgTr} style={{ height: '100%', top: 0, right: 0, position: 'absolute' }} />
      </div>
      <div style={{ position: 'absolute', bottom: 0, left: 0, right: 0, height: '63%' }}>
        <img src={AssetImages.bgB} style={{ height: '100%', width: '100%', top: '4%', position: 'absolute' }} />
        <img src={AssetImages.bgBl} style={{ height: '74%', bottom: '16%', left: 0, position: 'absolute' }} />
        <img src={AssetImages.bgBr} style={{ height: '47%', bottom: '39.5%', right: 0, position: 'absolute' }} />
      </div>
    </BgWrapper>
  )
}

export default function App() {
  //adjust body zIndex
  const [count, setOverlayCount] = useOverlayCount()
  console.log('////the overlay layer count:', count)
  //lock dark mode
  const [isDark, toggleSetDarkMode] = useDarkModeManager()
  const [mounted, setMounted] = useState(false)
  useEffect(() => {
    if (mounted) return
    setMounted(true)
    setOverlayCount(0)
    if (!isDark) {
      toggleSetDarkMode()
    }
  }, [isDark, mounted, setOverlayCount, toggleSetDarkMode])
  return (
    <ErrorBoundary>
      <Suspense fallback={null}>
        <Route component={GoogleAnalyticsReporter} />
        <Route component={DarkModeQueryParamReader} />
        <Route component={ApeModeQueryParamReader} />
        <AppWrapper>
          <Bg />
          <HeaderWrapper>
            <Header />
          </HeaderWrapper>
          <BodyWrapper overlayVisible={count > 0}>
            <ThemedBackground />
            <Popups />
            <Polling />
            <Web3ReactManager>
              <Switch>
                <Route exact strict path="/claim" component={OpenClaimAddressModalAndRedirectToSwap} />

                <Route exact strict path="/send" component={RedirectPathToSwapOnly} />
                <Route exact strict path="/swap/:outputCurrency" component={RedirectToSwap} />
                <Route exact strict path="/swap" component={Swap} />

                <Route exact strict path="/find" component={PoolFinder} />
                <Route exact strict path="/pool/v2" component={PoolV2} />
                <Route exact strict path="/pool" component={Pool} />
                <Route exact strict path="/pool/:tokenId" component={PositionPage} />

                <Route
                  exact
                  strict
                  path="/add/v2/:currencyIdA?/:currencyIdB?"
                  component={RedirectDuplicateTokenIdsV2}
                />
                <Route
                  exact
                  strict
                  path="/add/:currencyIdA?/:currencyIdB?/:feeAmount?"
                  component={RedirectDuplicateTokenIds}
                />

                <Route
                  exact
                  strict
                  path="/increase/:currencyIdA?/:currencyIdB?/:feeAmount?/:tokenId?"
                  component={AddLiquidity}
                />

                <Route exact strict path="/remove/v2/:currencyIdA/:currencyIdB" component={RemoveLiquidity} />
                <Route exact strict path="/remove/:tokenId" component={RemoveLiquidityV3} />

                <Route exact strict path="/migrate/v2" component={MigrateV2} />
                <Route exact strict path="/migrate/v2/:address" component={MigrateV2Pair} />

                <Route component={RedirectPathToSwapOnly} />
              </Switch>
            </Web3ReactManager>
            {/* <Marginer /> */}
          </BodyWrapper>
          <FooterWrapper>
            <Footer />
          </FooterWrapper>
        </AppWrapper>
      </Suspense>
    </ErrorBoundary>
  )
}
